import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AddItemComp  from "./Component/AddItemComp"

const AddItem =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AddItemComp />
        </div>
        <Footer />
        </>
    )
}

export default AddItem